import React, { useState, useEffect } from 'react';
import {
  getPotassiumAdjustedGroups,
  getPotassiumStats,
} from '../../../lib/api';
import { AdjustmentTab } from '../../../components/AdjustmentTab';
import { getChartColors } from '../../../services/chart-colors';

export function PotassiumAdjustments(props) {
  const {
    onLoad,
    onGroupsAdjustment,
    onFieldAdjustment,
    field,
    ...passThrough
  } = props;

  const [stats, setStats] = useState(null);
  const [groups, setGroups] = useState([]);
  const fieldAdjustment = field.fullFieldAdjustment || 0;

  useEffect(() => {
    Promise.all([getPotassiumStats(field), getPotassiumAdjustedGroups(field)])
      .then(([kStats, kGroups]) => {
        if (!kStats) throw new Error('No stats');
        setStats(kStats);
        setGroups(kGroups);
        onLoad('k', kGroups, fieldAdjustment);
      })
      .catch(() => onLoad('k'));
  }, [field, fieldAdjustment, onLoad]);

  return (
    stats && (
      <AdjustmentTab
        {...passThrough}
        ceiling={400}
        multipleOf={5}
        stats={stats}
        groups={groups}
        fieldAdjustment={fieldAdjustment}
        colors={getChartColors('potassium-rx')}
        xLabel={`Rate ${field.prescription.product} lbs/ac`}
        onGroupsAdjustment={(newGroups) => onGroupsAdjustment('k', newGroups)}
        onFieldAdjustment={(adjustment) => onFieldAdjustment('k', adjustment)}
      />
    )
  );
}
